import gql from 'graphql-tag'
export default gql`mutation deleteStrengthClassMutation($strengthClassId: Int!) {
  deleteStrengthClass(strengthClassId: $strengthClassId) {
    success
  }
}`